import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Header from './Header';

ReactDOM.render(<Header />, document.getElementById('root'));



